import React from "react";

//COMPONENTS
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import Button from "@/main/components/shared/button/button";
import { getTranslateByKey } from "@/main/services/utils";
import { QuoteXmlResponse } from "@/main/models/response";

// STYLES/COMPONENTS LOCAL
import * as S from "./styles";

interface IModalDownloadXMLProps {
	isOpenModal: boolean;
	dataPaintProject: QuoteXmlResponse | null;
	setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
	closeModal: () => void;
}
function ModalDownloadXML({ dataPaintProject, closeModal }: IModalDownloadXMLProps) {
	function handleClickClose(e: React.MouseEvent<HTMLButtonElement>) {
		e.preventDefault();
		e.stopPropagation();
		closeModal();
	}
	return (
		<S.Container>
			<p>{getTranslateByKey("information.useFileDownloadRefinity")}</p>
			<p>
				{getTranslateByKey("information.accessRefinity")}
				<S.Link href={dataPaintProject?.urlRefinity} target="_blank" rel="noreferrer">
					{dataPaintProject?.urlRefinity}
				</S.Link>
			</p>
			<S.AreaFooteButtons>
				<Button id="id-register-btn-close" type="submit" onClick={handleClickClose}>
					{getTranslateByKey("information.close")}
				</Button>
			</S.AreaFooteButtons>
		</S.Container>
	);
}

function WrapperModalDownloadXML(props: IModalDownloadXMLProps) {
	return (
		<KogModalFadeComponent isInModal closeByOverlay={false} open={props.isOpenModal} setOpen={props.setIsOpenModal}>
			<ModalDownloadXML {...props} />
		</KogModalFadeComponent>
	);
}

export default WrapperModalDownloadXML;
